import axios from '@/api/axiosInstance';

export default async function getJob(jobId) {
  const response = await axios({
    method: 'get',
    url: `${process.env.NEXT_PUBLIC_API}/jobs/${jobId}`,
  });

  return response.data;
}
